import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useScrollspy } from '../hooks/useScrollspy';
const NAV_LINKS = [{
  id: 'inicio',
  label: 'Inicio'
}, {
  id: 'quienes-somos',
  label: 'Quiénes somos'
}, {
  id: 'como-pensamos',
  label: 'Cómo pensamos'
}, {
  id: 'servicios',
  label: 'Servicios'
}, {
  id: 'modalidades',
  label: 'Modalidades'
}, {
  id: 'contacto',
  label: 'Contacto'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const activeSection = useScrollspy(NAV_LINKS.map(link => link.id));
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-6'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-6 md:px-8 flex items-center justify-between" data-id="element-147">
        {/* Logo */}
        <button onClick={() => scrollToSection('inicio')} className="flex-shrink-0 focus:outline-none" aria-label="Ir al inicio" data-id="element-148">
          <img src="https://cdn.magicpatterns.com/uploads/pYp6JwhpCzs9exReAGZP3x/eficci_sin_fondo.png" alt="eficci logo" className="h-8 md:h-10 w-auto object-contain" data-id="element-149" />
        </button>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-150">
          <ul className="flex items-center space-x-8" data-id="element-151">
            {NAV_LINKS.map(link => <li key={link.id} data-id="element-152">
                <button onClick={() => scrollToSection(link.id)} className={`font-body text-xs uppercase tracking-wider transition-colors duration-300 ${activeSection === link.id ? 'text-petrol-dark font-semibold border-b border-petrol-dark pb-1' : 'text-gray-600 hover:text-petrol-medium'}`} data-id="element-153">
                  {link.label}
                </button>
              </li>)}
          </ul>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-petrol-dark p-2 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-154">
          {isMobileMenuOpen ? <X size={24} data-id="element-155" /> : <Menu size={24} data-id="element-156" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 bg-white z-40 transition-transform duration-500 ease-in-out md:hidden flex flex-col pt-24 px-6 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-157">
        <ul className="flex flex-col space-y-6 mb-10" data-id="element-158">
          {NAV_LINKS.map(link => <li key={link.id} data-id="element-159">
              <button onClick={() => scrollToSection(link.id)} className={`font-heading text-3xl transition-colors ${activeSection === link.id ? 'text-petrol-medium' : 'text-petrol-dark'}`} data-id="element-160">
                {link.label}
              </button>
            </li>)}
        </ul>
      </div>
    </header>;
}